<script>
  import Menu from './Menu.svelte';
  import { onMount } from 'svelte';

  let logoUrl = '/assets/logo/origin_logo.png';
  let smallLogo = '/assets/logo/logo_symbol.png';

  export let name;
  export let showFullMenu;

  onMount(async () => {
  });
</script>

<!-- Static sidebar for desktop -->
<div class="hidden md:flex md:shrink-0">
  <div class="flex flex-col {showFullMenu ? 'w-64' : 'w-88'}">
    <!-- Sidebar component, swap this element with another sidebar if you like -->
    <div class="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white z-10">
      <div class="fixed flex-1 flex flex-col pt-5 pb-4 h-full overflow-y-auto {showFullMenu ? 'w-64' : 'w-22'}">
        <div class="flex items-center shrink-0 mb-12" class:px-4={showFullMenu} class:px-1={!showFullMenu} class:justify-center={!showFullMenu}>
          {#if showFullMenu}
            <img class="h-6 w-auto ml-4" src={logoUrl} alt="Workflow" />
          {:else} 
            <img class="h-6 w-auto" src={smallLogo} alt="Workflow" />
          {/if}
        </div>
        <Menu showMenuText={showFullMenu} />
      </div>
    </div>
  </div>
</div>
